// extracted by mini-css-extract-plugin
module.exports = {"root":"Member_root__LFcju","photo":"Member_photo__1ipAh","name":"Member_name__1xArU"};